import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { EntityProfileIndustry } from "@common/types/entity";
import { industryLabels } from "@components/entity/constants";
import { EmptyValue } from "@design-system/EmptyValue/EmptyValue";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { ChartOfAccountsTemplateRow } from "../chartOfAccountsTemplatesViewConfig";

const ALL_INDUSTRIES = Object.values(EntityProfileIndustry);

export const ChartOfAccountsTemplateIndustryCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, ChartOfAccountsTemplateRow, unknown>) => {
        const { industries } = row.original;
        // Verify actual coverage rather than a raw count, so a duplicate or an
        // unknown value can't masquerade as "every industry selected".
        const selectedIndustries = new Set(industries);
        const hasAllIndustries =
            industries.length > 0 &&
            ALL_INDUSTRIES.every((industry) =>
                selectedIndustries.has(industry),
            );

        const label = hasAllIndustries
            ? "All industries"
            : industries.map((industry) => industryLabels[industry]).join(", ");

        return (
            <ViewTableCell>
                {industries.length > 0 ? (
                    <span className="text-secondary text-truncate">
                        {label}
                    </span>
                ) : (
                    <EmptyValue />
                )}
            </ViewTableCell>
        );
    },
);
